export const STAFFING_STATUS = Object.freeze({
  unavailable: 'Unavailable',
  linked: 'Connected',
  unlinked: 'Disconnected'
})

export const AGENCY_TYPES = Object.freeze({
  independent_contractor: 'Independent Contractor',
  agency: 'Agency',
  marketplace: 'Marketplace'
})

export const CONTRACTOR_SUB_TYPES = Object.freeze([
  { id: 'independent_contractor', name: 'Independent' },
  { id: 'agency', name: 'Agency' },
  { id: 'marketplace', name: 'Marketplace' }
])
